
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 358.1 105.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M24.6 38.8c.5 4.7 5.6 16 9.5 18.6s22.2-4.8 15.2-18.5-25.2-4.8-24.7-.1zM42 14.7c23.1 2.1 28.6 23.4 25.4 38S42.9 74.6 42.9 74.6 51.1 86.2 54 92.8s-16.8 18.2-22.2 9.4S5.7 60.3.7 46.3 19 12.6 42 14.7zM64.8 8C63.7 2.2 84-1 85.3 3.2s4.9 23.6 4.9 23.6l16.2-25.2c3.1-4.3 17.1.8 18 9s-18.1 23.1-18.1 23.1 24.2 14.9 29.1 19.2-7.6 21.5-12.8 18.7-25.7-20.4-25.7-20.4l4.5 21.4c.8 4.8-19.4 8.8-21 3.9S66 13.8 64.8 8zM169.5 16.5h.4v72.4h-.4zM216.5 61.1v15.8h-11V29.6h16.7c2.9-.1 5.8.3 8.6 1.2 2.2.7 4.2 1.8 5.9 3.2 1.5 1.3 2.7 3 3.4 4.9.7 2 1.1 4 1.1 6.1 0 2.2-.4 4.4-1.1 6.5-.7 1.9-1.9 3.7-3.5 5.1-1.7 1.5-3.8 2.6-5.9 3.3-2.8.8-5.6 1.2-8.5 1.2h-5.7zm0-8.3h5.7c2.9 0 4.9-.7 6.2-2 1.3-1.6 2-3.7 1.9-5.8 0-1-.1-2-.5-3-.3-.9-.8-1.6-1.5-2.3-.7-.7-1.6-1.2-2.5-1.5-1.2-.4-2.4-.5-3.6-.5h-5.7v15.1zM256.4 68.2H274V77h-28.6V29.6h11v38.6z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M321.6 76.9h-8.5c-.8 0-1.7-.2-2.4-.7-.6-.4-1.1-1-1.3-1.7l-2.8-8.3h-18l-2.8 8.3c-.3.7-.7 1.2-1.3 1.6-.7.5-1.5.8-2.3.7h-8.6L292 29.6h11.2l18.4 47.3zm-30.4-18.1h12.9l-4.4-13c-.3-.8-.6-1.8-1-2.9s-.8-2.3-1.1-3.6c-.4 1.3-.7 2.5-1.1 3.7s-.7 2.1-1 2.9l-4.3 12.9zM340.9 58.9v18h-11v-18l-17.2-29.4h9.7c.8 0 1.6.2 2.3.7.6.5 1 1 1.4 1.7l6.7 13.8 1.5 3.1c.5.9.9 1.8 1.2 2.8.3-1 .7-1.9 1.2-2.8.5-.9.9-1.9 1.5-3l6.6-13.8c.1-.3.3-.6.5-.9.2-.3.5-.5.8-.8.3-.2.6-.4 1-.5.4-.1.8-.2 1.2-.2h9.8l-17.2 29.3z"}})])
          )
        }
      }
    